<p-table *ngIf="isStatementDocument" [scrollable]="true"
         [value]="[statementAndDocuments?.statementOfAccount]">
    <ng-template pTemplate="header">
        <tr>
            <th class="p-py-3" style="width: 140px">
                Invoice Number
            </th>

            <th style="width: 150px">
                Bill to
            </th>

            <th style="width: 130px">
                Transport Document
            </th>

            <th style="width: 140px">
                Invoice Date
            </th>

            <th style="width: 140px">
                Due Date
            </th>

            <th style="width: 120px">
                Invoice Currency
            </th>

            <th style="width: 130px">
                Amount
            </th>

            <th style="width: 130px">
                Transaction Amount
            </th>

            <th style="width: 120px">
                Due
            </th>
            <th style="width: 130px">
                Status
            </th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-statement>
        <tr class="divider-bottom">
            <td [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'" style="width: 140px"
                class="p-py-4 p-text-bold">{{statement?.invoiceNumber ? statement?.invoiceNumber : '-'}}</td>
            <td [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                style="width: 150px">{{statement?.billToPartyName ? statement?.billToPartyName : '-'}}</td>
            <td [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                style="width: 130px">{{statement?.transportDocument ? statement?.transportDocument : '-'}}</td>
            <td [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                style="width: 140px">{{statement?.invoiceDate ? (statement?.invoiceDate | date: 'dd-MMM-yyyy') : '-'}}</td>
            <td [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                style="width: 140px">{{statement?.dueDate ? (statement?.dueDate | date:'dd-MMM-yyyy') : '-'}}</td>
            <td [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                style="width: 120px">{{statement?.invoiceCurrency ? statement?.invoiceCurrency : '-'}}</td>
            <td [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                style="width: 130px">{{statement?.formattedInvoiceAmount ? statement?.formattedInvoiceAmount : '-'}}</td>
            <td [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                style="width: 130px">{{statement?.formattedTransactionalAmount ? statement?.formattedTransactionalAmount : '-'}}</td>

            <td [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                style="width: 120px">{{statement?.formattedDueAmount ? statement?.formattedDueAmount : '-'}}</td>

            <td [class]="statement?.status === 'Unpaid' ? 'p-text-danger' : 'p-text-warning'"
                style="width: 130px">{{statement?.status ? statement?.status : '-'}}</td>
        </tr>
    </ng-template>
</p-table>
<p-table *ngIf="isBookingDocument" [value]="[bookingDocuments?.shipmentBooking]" [scrollable]="true">
    <!--                        'calc(78vh - 10.5rem)'-->
    <ng-template pTemplate="header">
        <tr class="p-text-left width-100">
            <th pSortableColumn="shipmentType" class="p-py-3" style="width: 80px;">
                <div class="p-d-flex p-ai-center width-100">
                    <div>
                        Type
                    </div>
                    <div class="p-ml-2">
                        <p-sortIcon field="shipmentType"></p-sortIcon>
                    </div>
                </div>
            </th>
            <th pSortableColumn="bookingId" style="width: 140px;">
                <div class="p-d-flex p-ai-center width-100">
                    <div>
                        Booking Number
                    </div>
                    <div class="p-ml-2">
                        <p-sortIcon field="bookingId"></p-sortIcon>
                    </div>
                </div>
            </th>
            <th pSortableColumn="customerReferenceNumber" style="width: 180px;">
                <div class="p-d-flex p-ai-center width-100">
                    <div style="width: 70%">
                        Customer Reference Number
                    </div>
                    <div class="p-ml-2">
                        <p-sortIcon field="customerReferenceNumber"></p-sortIcon>
                    </div>
                </div>
            </th>
            <th pSortableColumn="transportDocument" style="width: 130px;">
                <div class="p-d-flex p-ai-center width-100">
                    <div style="width: 55%">
                        Transport Document
                    </div>
                    <div class="p-ml-2">
                        <p-sortIcon field="transportDocument"></p-sortIcon>
                    </div>
                </div>
            </th>
            <th pSortableColumn="bookingDate" style="width: 110px;">
                <div class="p-d-flex p-ai-center width-100">
                    <div>
                        Booking Date
                    </div>
                    <div class="p-ml-2">
                        <p-sortIcon field="bookingDate"></p-sortIcon>
                    </div>
                </div>
            </th>
            <th pSortableColumn="origin" style="width: 100px;">
                <div class="p-d-flex p-ai-center width-100">
                    <div>
                        Origin
                    </div>
                    <div class="p-ml-2">
                        <p-sortIcon field="origin"></p-sortIcon>
                    </div>
                </div>
            </th>
            <th pSortableColumn="departureDate" style="width: 100px;">
                <div class="p-d-flex p-ai-center width-100">
                    <div>
                        Departure
                    </div>
                    <div class="p-ml-2">
                        <p-sortIcon field="departureDate"></p-sortIcon>
                    </div>
                </div>
            </th>
            <th pSortableColumn="destination" style="width: 100px;">
                <div class="p-d-flex p-ai-center width-100">
                    <div>
                        Destination
                    </div>
                    <div class="p-ml-2">
                        <p-sortIcon field="destination"></p-sortIcon>
                    </div>
                </div>
            </th>
            <th pSortableColumn="arrivalDate" style="width: 90px;">
                <div class="p-d-flex p-ai-center width-100">
                    <div>
                        Arrival
                    </div>
                    <div class="p-ml-2">
                        <p-sortIcon field="arrivalDate"></p-sortIcon>
                    </div>
                </div>
            </th>
            <th pSortableColumn="status" style="width: 130px;">
                <div class="p-d-flex p-ai-center width-100">
                    <div>
                        Status
                    </div>
                    <div class="p-ml-2">
                        <p-sortIcon field="status"></p-sortIcon>
                    </div>
                </div>
            </th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-booking>
        <tr class="p-text-left divider-bottom width-100">
            <td class="p-py-4" style="width: 80px;">
                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                     class="p-d-flex p-ai-center width-100">
                    <div [ngClass]="getColourStatus(booking?.shipmentType)">
                        {{booking?.shipmentType ? booking?.shipmentType : '-'}}
                    </div>
                </div>
            </td>
            <td style="width: 140px;">
                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                     class="p-d-flex p-ai-center width-100">
                    <div class="p-text-bold">
                        {{booking?.bookingId ? booking?.bookingId : '-'}}
                    </div>
                </div>
            </td>
            <td style="width: 180px;">
                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                     class="p-d-flex p-ai-center width-100">
                    <div>
                        {{booking?.customerReferenceNumber ? booking?.customerReferenceNumber : '-'}}
                    </div>
                </div>
            </td>
            <td style="width: 130px">
                <div class="p-d-flex p-ai-center width-100">
                    <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                         [style]="booking?.blCount > 0 ? 'width: 80%' : ''">
                        {{booking?.transportDocument ? booking?.transportDocument : '-'}}
                    </div>
                    <div class="p-ml-2" *ngIf="booking?.blCount > 0">
                        <p-badge [value]="booking?.blCount"></p-badge>
                    </div>
                </div>
            </td>
            <td style="width: 110px;">
                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                     class="p-d-flex p-ai-center width-100">
                    <div>
                        {{booking?.bookingDate ? (booking?.bookingDate | date: 'dd-MMM-yyyy') : '-'}}
                    </div>
                </div>
            </td>
            <td style="width: 100px;">
                <div class="p-d-flex p-ai-center width-100">
                    <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                        {{booking?.origin ? booking?.origin : '-'}}
                    </div>
                </div>
            </td>
            <td style="width: 100px;">
                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                     class="p-d-flex p-ai-center width-100">
                    <div [class]="booking?.actualDepartureBoolean ? 'p-text-success' : 'p-text-warning'">
                        {{booking?.departureDate ? (booking?.departureDate | date: 'dd-MMM-yyyy') : '-'}}
                    </div>
                </div>
            </td>
            <td style="width: 100px">
                <div class="p-d-flex p-ai-center width-100">
                    <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                        {{booking?.destination ? booking?.destination : '-'}}
                    </div>
                </div>
            </td>
            <td style="width: 90px;">
                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                     class="p-d-flex p-ai-center width-100">
                    <div [class]="booking?.actualArrivalBoolean ? 'p-text-success' : 'p-text-warning'">
                        {{booking?.arrivalDate ? (booking?.arrivalDate | date: 'dd-MMM-yyyy') : '-'}}
                    </div>
                </div>
            </td>
            <td style="width: 130px;">
                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                     class="p-d-flex p-ai-center width-100">
                    <div [class]="booking?.status?.length > 0 ? 'rounded-normal white-color p-p-1 ' : ''"
                         [ngClass]="getColoredBookingStatus(booking?.status)">
                        {{booking?.status ? booking?.status : '-'}}
                    </div>
                </div>
            </td>
        </tr>
    </ng-template>

</p-table>

